import { CircularProgress, List, Stack, Typography } from "@mui/material"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import { Repeat } from "lib/@components/repeat"
import { MacroConsumerItem } from "./macro-consumer-item"

export function MacroConsumersList({ consumers = [], loading = false }) {
    const safeConsumers = toConsumerList(consumers)

    return (
        <Stack spacing={1.25} data-cy="macro-consumers-section">
            <Typography variant="subtitle2">Consumers</Typography>
            <If truthy={loading}>
                <Stack alignItems="center" sx={{ py: 1.5 }}>
                    <CircularProgress size={20} />
                </Stack>
                <Else>
                    <If truthy={safeConsumers.length > 0}>
                        <List disablePadding>
                            <Repeat list={safeConsumers} pass="consumer" keyFn="id" item={<MacroConsumerItem />} />
                        </List>
                        <Else>
                            <Typography>No consumers.</Typography>
                        </Else>
                    </If>
                </Else>
            </If>
        </Stack>
    )

    function toConsumerList(value) {
        if (Array.isArray(value)) return value
        return []
    }
}
